import { useState, useEffect } from 'react';
import { useRouter } from '../../hooks/router';
import CardChannel from './CardChannel'

export default ({
    category,
    index,
    btnCategory,
    activeChannelId,
    btn_favourites
}) => {

    return (
        <div className={"category_live " + (category.selected ? 'opened' : '')} >

            <h3 className={"nav__item-title "} onClick={(e) => btnCategory(index)}>{category.name}</h3>

            <p className='total_channels_count'>({category.channels ? category.channels.length : '0'})</p>

            <div className="channels_category">
                {
                    category.channels && category.channels.map((e, i) => {
                        return (
                            <CardChannel
                                btn_favourites={btn_favourites}
                                key={e.id}
                                channel={e}
                                activeChannelId={activeChannelId}
                            />
                        )
                    })
                }
            </div>

        </div>
    )

}